// extracted by mini-css-extract-plugin
export default {"user-avatar":"_1IDJa","userAvatar":"_1IDJa","pixelated":"_2zZAa"};